<template>
  <section
    style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
              <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
              Ajouter un nouveau Expert
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="addCard">
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-1">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajouter un nouveau Auteur</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="expertName"
                    label="Nom"
                    outlined
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <label class="mb-2">Bibliographie en Francais</label>
                  <VueEditor
                    v-model="expertBibliography"
                    auto-grow
                    outlined
                    placeholder="Bibliographie en Francais"
                    required
                  >
                  </VueEditor>
                </v-col>
                 <v-col cols="12" sm="12" md="12">
                  <label class="mb-2">Bibliographie en anglais</label>
                  <VueEditor
                    v-model="expertBibliographyEn"
                    auto-grow
                    outlined
                    placeholder="Bibliographie en anglais"
                    required
                  >
                  </VueEditor>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="
                        expertName.length <= 0 || expertBibliography.length <= 0 || expertBibliographyEn.length <= 0
                      "
                      class="info"
                      @click="ajoutExpert"
                      :loading="isButtonLoading"
                    >
                      {{ isButtonLoading ? "Chargement..." : "Sauvgarde" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Auteur</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="expertArray"
        class="elevation-1"
        item-key="id"
      >
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditExpert(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.id)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteExpert" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Expert ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteExpert = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteExpert()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      :top="snackbar.position === 'top'"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { mdiDeleteOutline, mdiPencil, mdiDatabasePlusOutline } from "@mdi/js";
import Constant from "@/utils/constants";
import { getAllExpert } from "@/views/qorani/services/services";

export default {
  components: { VueEditor },
  data() {
    return {
      snackbar: {
        position: "top",
        timeout: 3000,
        color: null,
        text: "",
        visible: false,
      },
      search: "",
      addCard: false,
      icons: {
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },
      valid: true,
      expertName: "",
      expertBibliography: "",
      expertBibliographyEn: "",
      expert: {
        name: "",
        bibliography: "",
        bibliographyEn: "",
      },
      expertArray: [],
      isLoadingTables: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Bibliography", value: "bibliography" },
        { text: "Bibliography en anglais", value: "bibliographyEn" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteExpert: false,
      isButtonLoading: false,
      idExpertSupprimer: "",
    };
  },
  methods: {
    redirectToEditExpert(item) {
      this.$router.push({
        name: "EditExpert",
        params: { id: item.id, item: item },
      });
    },
    suppressionAction(item) {
      this.idExpertSupprimer = item;
      this.deleteExpert();
    },
    async deleteExpert() {
      try {
        const response = await fetch(
          Constant.QORANI + `expert/delete/${this.idExpertSupprimer}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.ok) {
          this.ExpertArray = await getAllExpert();
          this.dialogDeleteExpert = false;
          this.snackbar.text = "L'auteur a été supprimé avec succès !";
          this.snackbar.color = "success";
          this.snackbar.visible = true;
        } else {
          this.dialogDeleteExpert = false;
          this.snackbar.text = "Erreur lors de la suppression";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } catch (error) {
        this.dialogDeleteExpert = false;
        this.snackbar.text =
          "Une erreur est survenue lors de la suppression de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
        this.dialogDeleteExpert = false;
      }
    },

    async ajoutExpert() {
      this.expert.name = this.expertName;
      this.expert.bibliography = this.expertBibliography;
      this.expert.bibliographyEn = this.expertBibliographyEn;
      try {
        const response = await fetch(Constant.QORANI + "expert/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.expert),
        });

        if (response.ok) {
          this.expertArray = await getAllExpert();
          this.expertName = "";
          this.expertBibliography = "";
          this.expertBibliographyEn = "";

          this.snackbar.text = "L'auteur a été ajouté avec succès !";
          this.snackbar.color = "success";
          this.snackbar.visible = true;
        } else {
          this.snackbar.text = "Erreur lors de l'ajout de l'auteur";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } catch (error) {
        this.snackbar.text =
          "Une erreur est survenue lors de l'ajout de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

    reinitialisationFormulaire() {
      this.$refs.form.reset();
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.expertArray = await getAllExpert();
    this.isLoadingTables = false;
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>